const MAX_AGENT_GIFT_SENT_PER_24_HOURS = 500 * 100
const MAX_PASSENGER_GIFT_SENT_PER_24_HOURS = 500 * 100
const AGENT_GIFT_SENT_WINDOW_MS = 24 * 60 * 60 * 1000
const PASSENGER_GIFT_SENT_WINDOW_MS = 24 * 60 * 60 * 1000

function remainingGiftAllowance ({ sentInLast24Hours, limit }) {
  const cap = limit
  const alreadySent = Math.max(Number(sentInLast24Hours) || 0, 0)
  const remaining = cap - alreadySent
  return remaining > 0 ? remaining : 0
}

function giftAmountWithinAllowance ({ amount, sentInLast24Hours, limit }) {
  return (Number(amount) || 0) <= remainingGiftAllowance({
    sentInLast24Hours: sentInLast24Hours,
    limit: limit
  })
}

function giftAllowanceErrorMessage ({ sentInLast24Hours, formatCurrency, limit, giftKind }) {
  const remaining = remainingGiftAllowance({
    sentInLast24Hours: sentInLast24Hours,
    limit: limit
  })
  return giftKind + ' are limited to ' + formatCurrency(limit) +
    ' per 24 hours. You have ' + formatCurrency(remaining) + ' left today.'
}

function giftSentWindowStart (now, windowMs) {
  return new Date((now || Date.now()) - windowMs)
}

function remainingAgentGiftAllowance ({ sentInLast24Hours, limit }) {
  return remainingGiftAllowance({
    sentInLast24Hours: sentInLast24Hours,
    limit: limit || MAX_AGENT_GIFT_SENT_PER_24_HOURS
  })
}

function remainingPassengerGiftAllowance ({ sentInLast24Hours, limit }) {
  return remainingGiftAllowance({
    sentInLast24Hours: sentInLast24Hours,
    limit: limit || MAX_PASSENGER_GIFT_SENT_PER_24_HOURS
  })
}

function agentGiftAmountWithinAllowance ({ amount, sentInLast24Hours, limit }) {
  return giftAmountWithinAllowance({
    amount: amount,
    sentInLast24Hours: sentInLast24Hours,
    limit: limit || MAX_AGENT_GIFT_SENT_PER_24_HOURS
  })
}

function passengerGiftAmountWithinAllowance ({ amount, sentInLast24Hours, limit }) {
  return giftAmountWithinAllowance({
    amount: amount,
    sentInLast24Hours: sentInLast24Hours,
    limit: limit || MAX_PASSENGER_GIFT_SENT_PER_24_HOURS
  })
}

function agentGiftAllowanceErrorMessage ({ sentInLast24Hours, formatCurrency }) {
  return giftAllowanceErrorMessage({
    sentInLast24Hours: sentInLast24Hours,
    formatCurrency: formatCurrency,
    limit: MAX_AGENT_GIFT_SENT_PER_24_HOURS,
    giftKind: 'Agent gifts'
  })
}

function passengerGiftAllowanceErrorMessage ({ sentInLast24Hours, formatCurrency }) {
  return giftAllowanceErrorMessage({
    sentInLast24Hours: sentInLast24Hours,
    formatCurrency: formatCurrency,
    limit: MAX_PASSENGER_GIFT_SENT_PER_24_HOURS,
    giftKind: 'Passenger gifts'
  })
}

function agentGiftSentWindowStart (now) {
  return giftSentWindowStart(now, AGENT_GIFT_SENT_WINDOW_MS)
}

function passengerGiftSentWindowStart (now) {
  return giftSentWindowStart(now, PASSENGER_GIFT_SENT_WINDOW_MS)
}

module.exports = {
  MAX_AGENT_GIFT_SENT_PER_24_HOURS,
  MAX_PASSENGER_GIFT_SENT_PER_24_HOURS,
  AGENT_GIFT_SENT_WINDOW_MS,
  PASSENGER_GIFT_SENT_WINDOW_MS,
  remainingAgentGiftAllowance,
  remainingPassengerGiftAllowance,
  agentGiftAmountWithinAllowance,
  passengerGiftAmountWithinAllowance,
  agentGiftAllowanceErrorMessage,
  passengerGiftAllowanceErrorMessage,
  agentGiftSentWindowStart,
  passengerGiftSentWindowStart
}
